import {
  CategoryLinkedProperties,
  LinkedProperty,
  LinkedView,
} from "../../../view/linked.property";
import { SplitCategoryAsObjectType } from "../../../types/split-category-type";

/**
 * SplitCategory will no longer be used in transactions as we are now only saving the split
 * in the Allocation part of the transaction model. This class is left here to be used in
 * Accounts when we later store the default category for an account.
 */
export class SplitCategory implements LinkedProperty<CategoryLinkedProperties> {
  categoryLink: LinkedView = { id: "" };
  weight: number;
  roundingDefault: boolean; // only one of these in the transaction array of SplitCategories can be true

  toSplitCategoryAsObjectType(): SplitCategoryAsObjectType {
    return {
      ctId: this.categoryLink.id,
      wgt: this.weight,
      rdf: this.roundingDefault,
    };
  }
}
